import { z } from 'zod';

// Interfaces para campos do formulário
export interface BaseField {
  id: string;
  label: string;
  placeholder?: string;
  type?: string;
  optional?: boolean;
}

export interface SingleField extends BaseField {
  isGroup: false;
  value?: string;
  onChange: (value: string) => void;
}

export interface GroupField extends BaseField {
  isGroup: true;
  fields: (BaseField & {
    value?: string | boolean;
    onChange: (value: string | boolean) => void;
  })[];
}

export type Question = SingleField | GroupField;

export interface FormFieldProps extends BaseField {
  value?: string | boolean;
  onChange: (value: string | boolean) => void;
}

// Schema de validação
export const formSchema = z.object({
  newsletter: z.string().min(1, "por favor, selecione uma marca"),
  main: z.string().min(1, "por favor, selecione uma categoria principal"),
  issue: z.string().min(1, "por favor, selecione um problema"),
  description: z.string().min(10, "a descrição deve ter pelo menos 10 caracteres"),
  email: z.string().email("e-mail inválido").min(1, "e-mail é obrigatório"),
});

export type FormValues = z.infer<typeof formSchema>;
